import React, { useState } from 'react';
import Card from 'components/card/Card';
import { Tab, Tabs, TabList, TabPanels, TabPanel } from '@chakra-ui/react';
import Branches from './components/stores';
import About from './components/about';
import CompanyConfig from './components/CompanyConfig/CompanyConfig';
import { useLocation } from 'react-router-dom';

export default function Company() {
  return (
    <>
      <Card
        direction='column'
        w='100%'
        px='20px'
        mt={{ base: '140px', md: '120px' }}
        overflowX={{ sm: 'scroll', lg: 'hidden' }}>
        <Tabs
          isFitted
          variant='enclosed'>
          <TabList mb='1em'>
            <Tab>Company Details</Tab>
            <Tab>Branches</Tab>
            <Tab> Config</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <About />
            </TabPanel>
            <TabPanel>
              <Branches />
            </TabPanel>
            <TabPanel>
              <CompanyConfig />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </>
  );
}
